import React from "react";
import { useLocation } from "react-router-dom";
import './TransferSuccess.css'
import { useNavigate } from "react-router-dom";
import Wright from '../src/assets/Check-duotone.svg'

const TransferSuccess = () => {
  const location = useLocation();
  const { recipientEmail, amount } = location.state || {};

  const navigate = useNavigate()
  return (
    <div className="success-container">
      <img className="successImage" src={Wright} alt="Successful Icon" />
      <h1>Transfer Successful</h1>
      {recipientEmail && amount ? (
        <p style={{width: '90%', textAlign: 'center', marginTop: 16,}}>
          You have successfully transferred ${amount} to {recipientEmail}.
        </p>
      ) : (
        <p>Your transfer has been successfully completed.</p>
      )}

      <button onClick={() => navigate('/dashboard')} className="successButton">Okay, Thank you</button>
    </div>
  );
};

export default TransferSuccess;
